export function initExportBanner() {
    const banner = document.querySelector('.export-banner');
    if (!banner) return;

    const items = banner.querySelectorAll('.export-banner__right .item[data-country]');
    const svgCountries = banner.querySelectorAll('.export-map__country[data-country]');
    const svgMarkers = banner.querySelectorAll('.export-map__marker[data-country]');
    const partnerBtn = banner.querySelector('.export-banner__left .btn');

    function setActive(country) {
        items.forEach(el => el.classList.toggle('is-active', el.dataset.country === country));
        svgCountries.forEach(el => el.classList.toggle('is-active', el.dataset.country === country));
        svgMarkers.forEach(el => el.classList.toggle('is-active', el.dataset.country === country));
    }

    if (partnerBtn) {
        partnerBtn.addEventListener('click', function (e) {
            e.preventDefault();
            if (typeof window.openConsultationModal === 'function') {
                window.openConsultationModal();
            } else {
                window.dispatchEvent(new CustomEvent('open-consultation-modal'));
            }
        });
    }

    items.forEach(el => {
        el.addEventListener('mouseenter', () => setActive(el.dataset.country));
        el.addEventListener('mouseleave', () => setActive(null));
    });

    svgCountries.forEach(el => {
        el.addEventListener('mouseenter', () => setActive(el.dataset.country));
        el.addEventListener('mouseleave', () => setActive(null));
    });

    svgMarkers.forEach(el => {
        el.addEventListener('mouseenter', () => setActive(el.dataset.country));
        el.addEventListener('mouseleave', () => setActive(null));
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExportBanner);
} else {
    initExportBanner();
}
